import { mockData } from "./Mock";
import { Category, HomeShowItem } from "../../models/CategoryManagement";

const mockIconUrl = "https://superthem.oss-cn-shanghai.aliyuncs.com/category-icon/category_1755265730623.png"

const mockCategories: Category[] = [
    {
        id: 1,
        name: "数码产品",
        iconUrl: mockIconUrl,
        parentId: 0,
        keywords: "手机,电脑,平板,数码"
    },
    {
        id: 2,
        name: "服装鞋帽",
        iconUrl: mockIconUrl,
        parentId: 0,
        keywords: "男装,女装,童装,鞋帽"
    },
    {
        id: 3,
        name: "家居用品",
        iconUrl: mockIconUrl,
        parentId: 0,
        keywords: "家具,装饰,厨具,清洁"
    },
    {
        id: 4,
        name: "美妆护肤",
        iconUrl: mockIconUrl,
        parentId: 0,
        keywords: "护肤,彩妆,香水,美容"
    },
    {
        id: 5,
        name: "食品饮料",
        iconUrl: mockIconUrl,
        parentId: 0,
        keywords: "零食,饮料,生鲜,调味"
    },
    {
        id: 11,
        name: "智能手机",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "苹果,华为,小米,OPPO"
    },
    {
        id: 12,
        name: "笔记本电脑",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "联想,戴尔,华硕,苹果"
    },
    {
        id: 13,
        name: "笔记本电脑",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "联想,戴尔,华硕,苹果"
    },
    {
        id: 14,
        name: "笔记本电脑",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "联想,戴尔,华硕,苹果"
    },
    {
        id: 15,
        name: "笔记本电脑",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "联想,戴尔,华硕,苹果"
    },
    {
        id: 16,
        name: "笔记本电脑",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "联想,戴尔,华硕,苹果"
    },
    {
        id: 17,
        name: "笔记本电脑",
        iconUrl: mockIconUrl,
        parentId: 1,
        keywords: "联想,戴尔,华硕,苹果"
    },
    {
        id: 21,
        name: "男装",
        iconUrl: mockIconUrl,
        parentId: 2,
        keywords: "T恤,衬衫,裤子,外套"
    },
    {
        id: 22,
        name: "女装",
        iconUrl: mockIconUrl,
        parentId: 2,
        keywords: "连衣裙,上衣,裤子,外套"
    },
    {
        id: 31,
        name: "家具",
        iconUrl: mockIconUrl,
        parentId: 3,
        keywords: "沙发,床,桌子,椅子"
    },
    {
        id: 41,
        name: "护肤",
        iconUrl: mockIconUrl,
        parentId: 4,
        keywords: "洁面,爽肤水,精华,面霜"
    },
    {
        id: 51,
        name: "零食",
        iconUrl: mockIconUrl,
        parentId: 5,
        keywords: "饼干,糖果,坚果,膨化"
    }
];

const mockHomeShows: HomeShowItem[] = [
    {
        index: 0,
        secondCategory: mockCategories[5] // 智能手机
    },
    {
        index: 1,
        secondCategory: mockCategories[6] // 笔记本电脑
    },
    {
        index: 2,
        secondCategory: mockCategories[7] // 男装
    },
    {
        index: 3,
        secondCategory: mockCategories[8] // 女装
    },
    {
        index: 4,
        secondCategory: mockCategories[9] // 家具
    },
    {
        index: 5,
        secondCategory: mockCategories[10] // 护肤
    },
    {
        index: 6,
        secondCategory: mockCategories[11] // 零食
    }
];

mockData.set("all_categories", mockCategories);
mockData.set("home_shows", mockHomeShows); 